import { call, put, all, takeEvery } from 'typed-redux-saga/macro'
import { SagaReturnType } from 'redux-saga/effects'

import {
  GET_AD_SERVER_LIST,
  getAdServerListSuccess,
  getAdServerListFailure,
  CREATE_AD_SERVER,
  createAdServerSuccess,
  createAdServerFailure,
  UPDATE_AD_SERVER,
  updateAdServerSuccess,
  updateAdServerFailure,
  GET_AD_SERVER_LINE_ITEMS,
  getAdServerLineItemsSuccess,
  getAdServerLineItemsFailure
} from '../actions/adServer'

import {
  createAdServerService,
  getAdServerLineItemsService,
  getAdServerListService,
  updateAdServerService
} from '../services/adServer'
import { CreateAdServerPayload, GetAdServerLineItemsPayload, UpdateAdServerPayload } from '../types/adServer'

function* adServerWatcher() {
  yield* all([
    // PLOP_APPEND_PATTERN_ANCHOR_WATCHER
    takeEvery(GET_AD_SERVER_LINE_ITEMS, getAdServerLineItemsWorker),
    takeEvery(GET_AD_SERVER_LIST, getAdServerListWorker),
    takeEvery(CREATE_AD_SERVER, createAdServerWorker),
    takeEvery(UPDATE_AD_SERVER, updateAdServerWorker)
  ])
}

// PLOP_APPEND_PATTERN_ANCHOR_WORKER
function* getAdServerListWorker(): Generator {
  try {
    type ResponseType = SagaReturnType<typeof getAdServerListService>
    const getAdServerListResponse: ResponseType = yield call(getAdServerListService)
    yield put(getAdServerListSuccess(getAdServerListResponse))
  } catch (error: any) {
    yield put(getAdServerListFailure(error))
  }
}

function* createAdServerWorker({ serverData }: CreateAdServerPayload): Generator {
  try {
    type ResponseType = SagaReturnType<typeof createAdServerService>
    const createAdServerResponse: ResponseType = yield call(createAdServerService, serverData)
    yield put(createAdServerSuccess(createAdServerResponse))
  } catch (error: any) {
    yield put(createAdServerFailure(error))
  }
}

function* updateAdServerWorker({ updateAdServerData }: UpdateAdServerPayload): Generator {
  try {
    type ResponseType = SagaReturnType<typeof updateAdServerService>
    const updateAdServerResponse: ResponseType = yield call(updateAdServerService, updateAdServerData)
    yield put(updateAdServerSuccess(updateAdServerResponse))
  } catch (error: any) {
    yield put(updateAdServerFailure(error))
  }
}

function* getAdServerLineItemsWorker({ params }: GetAdServerLineItemsPayload): Generator {
  try {
    type ResponseType = SagaReturnType<typeof getAdServerLineItemsService>
    const getAdServerLineItemsResponse: ResponseType = yield call(getAdServerLineItemsService, params)
    yield put(getAdServerLineItemsSuccess(getAdServerLineItemsResponse))
  } catch (error: any) {
    yield put(getAdServerLineItemsFailure(error))
  }
}

export default adServerWatcher
